/**
 * The contents of this file are subject to the license and copyright
 * detailed in the LICENSE_ATMIRE and NOTICE_ATMIRE files at the root of the source
 * tree and available online at
 *
 * https://www.atmire.com/software-license/
 */
import { Component } from '@angular/core';
import { Bundle } from '../../../../../../app/core/shared/bundle.model';
import { AtmireAbstractListableElementComponent } from '../../../../../../app-atmire/shared/object-collection/shared/object-collection-element/atmire-abstract-listable-element.component';
import { ViewMode } from '../../../../../../app/core/shared/view-mode.model';
import { listableObjectComponent } from '../../../../../../app/shared/object-collection/shared/listable-object/listable-object.decorator';
import { Context } from '../../../../../../app/core/shared/context.model';

@Component({
  selector: 'ds-bundle-list-element',
  templateUrl: './bundle-list-element.component.html'
})
/**
 * This component is automatically used to create a list view for Bundle objects
 */
@listableObjectComponent(Bundle, ViewMode.ListElement, Context.Any, 'atmire')
export class BundleListElementComponent extends AtmireAbstractListableElementComponent<Bundle> {
}
